module.exports = __webpack_public_path__ + "static/media/Img_1.91a34802.JPG";